import { Box } from '@mui/material';
import type { ReactNode } from 'react';
import { ICON_PX } from '~/theme/iconSizes';

/**
 * The lead of a menu row, as one cell before its name: a status mark in an
 * icon column, then a dataset chip at its own width. A row with only one of
 * them shows only that one. The mark sits closer to its chip than the row's
 * own gap, so the two read as one lead.
 */
export default function MenuRowLead({
    mark,
    chip,
}: {
    /**
     * A status glyph, such as an approval status. `null` keeps the column
     * empty, so names line up with those of rows that have a mark.
     */
    mark?: ReactNode;
    chip?: ReactNode;
}) {
    return (
        <Box display="inline-flex" alignItems="center" gap={0.5} flexShrink={0}>
            {mark !== undefined && (
                <Box
                    display="flex"
                    justifyContent="center"
                    width={ICON_PX}
                    flexShrink={0}
                >
                    {mark}
                </Box>
            )}
            {chip}
        </Box>
    );
}
